<template>
  <div>
    <div class="flex items-center flex-col">
      <div class="my-3 text-center">
        <span class=" block   text-2xl">Account Receivables</span>
        <span class="block font-semibold text-lg">₦ 877,908.50</span>
        <span class="block text-gray-500">12 Receivables</span>
      </div>

      <apexchart
        type="donut"
        width="380"
        :options="chartOptions"
        :series="series"
      >
      </apexchart>
    </div>

    <div class="my-3 px-3 w-full">
      <div class=" w-full flex my-3 justify-between">
        <div>
          <span class=" font-semibold">Top Debtors</span>
          <span class="mx-1 cursor-pointer py-1 text-primary-yellow"
            >By Aging</span
          >
        </div>

        <button class="text-primary-yellow">View All</button>
      </div>

      <div class="grid grid-cols-3">
        <div class="pr-2">
          <div class="flex items-center">
            <img
              src="@/assets/images/billing/due-today.svg"
              alt="Overview svg"
            />
            <span class=" font-semibold pl-1 text-xl" style="color:#D72638"
              >08</span
            >
            <span class="pl-1 text-sm ">Due Today</span>
          </div>
          <span class=" font-semibold text-lg">₦1,234,560.55</span>
        </div>

        <div class="pr-2">
          <div class="flex items-center">
            <img
              src="@/assets/images/billing/due-7-days.svg"
              alt="Overview svg"
            />
            <span class=" font-semibold pl-1 text-xl" style="color:#7A90A7"
              >02</span
            >
            <span class="pl-1 text-sm ">Due in 7 days</span>
          </div>
          <span class=" font-semibold">₦ 459,870.40</span>
        </div>

        <div>
          <div class="flex items-center">
            <img
              src="@/assets/images/billing/due-30-days.svg"
              alt="Overview svg"
            />
            <span class=" font-semibold pl-1 text-xl" style="color:#09B78A"
              >08</span
            >
            <span class="pl-1 text-sm ">Due in 30 days</span>
          </div>
          <span class=" font-semibold">₦ 905,080.33</span>
        </div>
      </div>
    </div>

    <div class=" bg-gray-200 rounded p-2 my-5 mx-3">
      <span class=" text-gray-700 pr-2">Receivables Due</span>
      <select class=" bg-transparent font-semibold">
        <option value="sss">Today</option>
      </select>
    </div>

    <div class=" mx-3 mb-3">
      <div class="grid grid-cols-12 mb-1">
        <span class=" col-span-6  text-gray-500">Name</span>
        <span class=" col-span-3 text-right  text-gray-500">Amount</span>
        <span class=" col-span-3 text-right  text-gray-500">Aging</span>
      </div>
      <div
        v-for="(i, index) in 3"
        :key="index"
        class="grid grid-cols-12 p-1 "
        :class="{ 'bg-gray-100': index % 2 == 0 }"
      >
        <span class=" col-span-6 font-semibold text-black ">Agrico Ltd</span>
        <span class=" col-span-3 text-right font-semibold text-black  "
          >₦ 324,000.90</span
        >
        <span class=" col-span-3 text-right font-semibold text-black"
          >28 Days</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      series: [30, 50, 10, 10],
      chartOptions: {
        chart: {
          width: 380,
          type: "donut",
        },
        colors: ["#D72638", "#7A90A7", "#09B78A", "#FCC210"],
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
        legend: {
          position: "bottom",
          offsetY: 0,
        },
        labels: [
          "Due today",
          "Past 7 days",
          "Past 30 days",
          "More than 30 days",
        ],
      },
    };
  },
};
</script>

<style></style>
